import React from 'react'
import _PageHeader_Loader from 'containers/Page/Header/_components/Loader/_PageHeader_Loader'
import importedComponent from 'react-imported-component'

export default importedComponent(
  () => import('./PageHeader'), {
    LoadingComponent: _PageHeader_Loader
  }
)
